export default __webpack_public_path__ + "static/media/Gilroy-BoldItalic.82ec4c70.woff";